import {
  cn,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@gearbox-protocol/deploy-tools-ui";
import type { TaskDefinitionFormSchema } from "api";
import { FileUpload } from "components/file-upload";
import type { FC } from "react";
import type { UseFormReturn } from "react-hook-form";

interface Props {
  form: UseFormReturn<TaskDefinitionFormSchema>;
  className?: string;
}

const TaskDefinitionArtifacts: FC<Props> = ({ form, className }) => {
  return (
    <FormField
      control={form.control}
      name="artifacts"
      render={({ field }) => (
        <FormItem className="flex flex-row gap-x-1">
          <FormLabel className="w-24 pt-2">Configuration files</FormLabel>

          <div className={cn("flex flex-col gap-y-1 flex-1", className)}>
            <FileUpload files={field.value} onChange={field.onChange} />
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
};

export default TaskDefinitionArtifacts;
